module.exports = __webpack_public_path__ + "static/TRUENDO-2163ef4710b74ce793c8a5accd863d52.jpg";